module.exports = __webpack_public_path__ + "static/img/34.1b25bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/34.png
// module id = WwvS
// module chunks = 1